// src/pages/PhoneSelection.js
import React from 'react';
import { Link } from 'react-router-dom';
// Reverted back to Si icons as requested
import {
    SiApple, SiSamsung, SiGoogle, SiOneplus, SiHuawei,
    SiNokia, SiMotorola, SiOppo, SiXiaomi
} from 'react-icons/si';
// Kept Fa icons for general UI elements
import { FaWrench } from 'react-icons/fa';


// Button style for consistency
const contactLinkStyle = {
  display: 'inline-block', alignItems: 'center', background: '#6c757d', color: '#fff',
  border: '1px solid #6c757d', borderRadius: '4px', padding: '0.5rem 1rem',
  cursor: 'pointer', fontSize: '0.9rem', textDecoration: 'none', fontWeight: '500',
  transition: 'background-color 0.2s, border-color 0.2s', marginLeft: '4px',
};

// --- Brand Data using Si icons ---
// Removed iconColor, using Si icons directly
const phoneBrands = [
    { name: 'iPhone', path: '/phone/iphone', Icon: SiApple, ariaLabel: 'Select Apple iPhone' },
    { name: 'Samsung', path: '/phone/samsung', Icon: SiSamsung, ariaLabel: 'Select Samsung Galaxy Phone' },
    { name: 'Pixel', path: '/phone/pixel', Icon: SiGoogle, ariaLabel: 'Select Google Pixel Phone' },
    { name: 'OnePlus', path: '/phone/oneplus', Icon: SiOneplus, ariaLabel: 'Select OnePlus Phone' },
    { name: 'Huawei', path: '/phone/huawei', Icon: SiHuawei, ariaLabel: 'Select Huawei Phone' },
    { name: 'Nokia', path: '/phone/nokia', Icon: SiNokia, ariaLabel: 'Select Nokia Phone' },
    { name: 'Motorola', path: '/phone/motorola', Icon: SiMotorola, ariaLabel: 'Select Motorola Phone' },
    { name: 'Oppo', path: '/phone/oppo', Icon: SiOppo, ariaLabel: 'Select Oppo Phone' },
    { name: 'Redmi', path: '/phone/redmi', Icon: SiXiaomi, ariaLabel: 'Select Xiaomi Phone' },
];
// --- ---

function PhoneSelection() {
  return (
    <main className="page-container phone-selection-page" style={{ padding: '2rem 1rem' }}>
      <header style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
        <h1 style={{ fontSize: '2rem', color: '#007BFF', marginBottom: '0.5rem' }}>Select Your Phone Brand</h1>
        <p style={{ fontSize: '1.1rem', color: '#6c757d' }}>Choose your phone manufacturer to view models and repair options.</p>
      </header>

      {/* Grid for selecting brand */}
      {/* className="phone-grid" needs CSS for grid layout */}
      <div className="phone-grid" style={gridStyle}>
        {phoneBrands.map((brand) => (
          <Link
            key={brand.name}
            to={brand.path}
            className="phone-item" // Needs CSS
            style={phoneItemStyle} // Basic inline styles
            title={`View ${brand.name} Models`} // Corrected template literal
            role="button"
            aria-label={brand.ariaLabel}
          >
            <div className="phone-logo" style={logoContainerStyle}>
              {/* Render Si icon, set color explicitly to black/dark grey */}
              <brand.Icon size={50} style={{ color: '#6c757d' }} />
            </div>
            <h3 style={itemHeadingStyle}>{brand.name}</h3>
            <span style={itemTextStyle}>View Models & Repairs</span>
          </Link>
        ))}
      </div>

      {/* Additional Info Section */}
      <section className="phone-extra-info" style={extraInfoStyle} aria-labelledby="phone-info-heading">
        <h4 id="phone-info-heading" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '1rem' }}>
          <FaWrench />
          We Fix Them All! (Usually...)
        </h4>
        <p>
           Cracked screens, battery swaps, water damage, and more - our expert technicians service most phone brands and models. All repairs include our standard warranty.
        </p>
        <p style={{ marginTop: '1.5rem' }}>
          Don't see your brand or have an older model?{' '}
          <Link to="/contact" style={contactLinkStyle}>
            Contact Us
          </Link>
          {' '}for a custom quote.
        </p>
      </section>
    </main>
  );
}

// --- Inline Styles (Keep as previously defined) ---
const gridStyle = { /* ... */ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '2rem', marginBottom: '3rem', };
const phoneItemStyle = { /* ... */ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.5rem', border: '1px solid #dee2e6', borderRadius: '8px', textDecoration: 'none', color: '#495057', minWidth: '200px', textAlign: 'center', transition: 'transform 0.2s ease, box-shadow 0.2s ease', boxShadow: '0 2px 4px rgba(108, 117, 125, 0.05)', backgroundColor: '#fff', };
const logoContainerStyle = { /* ... */ marginBottom: '1rem', height: '50px', display: 'flex', alignItems: 'center', };
const itemHeadingStyle = { /* ... */ margin: '0.5rem 0', fontSize: '1.2rem', color: '#007BFF', };
const itemTextStyle = { /* ... */ fontSize: '0.9rem', color: '#6c757d', };
const extraInfoStyle = { /* ... */ marginTop: '3rem', padding: '2rem', backgroundColor: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: '8px', textAlign: 'center', maxWidth: '650px', marginLeft: 'auto', marginRight: 'auto', color: '#495057', };
// --- ---

export default PhoneSelection;